import { OpenInNewOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'

import { useOpenReportFile } from 'features/yieldbirdWrapperAgent/hooks/useOpenReportFile'

import type { Report, ReportFileKind } from 'features/yieldbirdWrapperAgent/api/types'
import type { MouseEvent } from 'react'

const MIDDLE_MOUSE_BUTTON: MouseEvent<HTMLButtonElement>['button'] = 1

type Props = {
  jobId: Report['jobId']
  kind: ReportFileKind
}

export const OpenFileButton = ({ jobId, kind }: Props): React.JSX.Element => {
  const { open } = useOpenReportFile()

  return (
    <IconButton
      data-cy={`open-${kind}-button`}
      onAuxClick={(event: MouseEvent<HTMLButtonElement>): void => {
        if (event.button === MIDDLE_MOUSE_BUTTON) {
          void open(jobId, kind)
        }
      }}
      onClick={() => void open(jobId, kind)}
      size='small'
    >
      <OpenInNewOutlined />
    </IconButton>
  )
}
